import React from "react";
import { Container } from "react-bootstrap";

const NotFound: React.FC = () => {
  return (
    <Container>
      <h1>404</h1>
    </Container>
  );
};

export default NotFound;
